import React from 'react';
import { List, Datagrid, TextField, ReferenceField, EditButton, DateField } from 'react-admin';
import Icon from '@material-ui/icons/CardGiftcard';
import ImageGridField from 'components/ImageGridField';
import EditForm from './EditForm';
import CreateForm from './CreateForm';

export const VoucherIcon = Icon;

export const VoucherList = props => (
  <List {...props}>
    <Datagrid>
      <ImageGridField source="cover_url" title="title" label="Cover" />
      <ReferenceField label="Car Brand" sortBy="car_brands.name" source="car_brand_id" reference="brands">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        label="Car Model"
        sortBy="car_models.name"
        source="car_model_id"
        reference="models"
        allowEmpty={true}
      >
        <TextField source="name" />
      </ReferenceField>
      <TextField source="title" />
      <TextField source="type" />
      <DateField source="started_at" label="Start Date" />
      <DateField source="expired_at" label="End Date" />
      <EditButton />
    </Datagrid>
  </List>
);

export const VoucherCreate = CreateForm;

export const VoucherEdit = EditForm;



// WEBPACK FOOTER //
// ./src/containers/Voucher/index.js